import * as types from 'actions/overlay/types';

const initialState = {
  show: false,
  type: null,
  options: null,
  returnFocusTo: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW:
      const { returnFocusTo, type, options } = action.payload;
      return { ...state, show: true, type, options, returnFocusTo };
    case types.HIDE:
      return { ...initialState };
    default:
      return state;
  }
};
